export const kioskSimulator = {
  name: 'Kiosk Simulator |||| Kiosk Simulators',
};
export default kioskSimulator;